import React, { useState, useEffect } from 'react';

const IndexDashboard = ({ indexes, loading, error }) => {
  const [health, setHealth] = useState(null);

  useEffect(() => {
    fetch('/api/health')
      .then(res => res.json())
      .then(data => setHealth(data))
      .catch(() => setHealth({ status: 'error' }));
  }, []);

  if (loading) {
    return (
      <div style={{ fontFamily: 'monospace', padding: '20px' }}>
        <h1>CMS MPF Provider Directory</h1>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div style={{ fontFamily: 'monospace', padding: '20px', maxWidth: '1200px' }}>
      <h1>CMS MPF Provider Directory</h1>

      {/* Health Info */}
      <div style={{ marginBottom: '30px', borderBottom: '1px solid #000', paddingBottom: '10px' }}>
        <h2>Health Status</h2>
        {health && (
          <pre>
Status: {health.status}
Timestamp: {health.timestamp || new Date().toISOString()}
          </pre>
        )}
      </div>

      {/* Index Info */}
      <div>
        <h2>Available Indexes</h2>
        {error && <p style={{ color: 'red' }}>Error: {error}</p>}

        <p>Total Contracts: {indexes.length}</p>
        <p>Year Filter: {indexes[0]?.year || 'All Years'}</p>

        {indexes.length > 0 ? (
          <table style={{ borderCollapse: 'collapse', width: '100%', marginTop: '20px' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #000' }}>
                <th style={{ textAlign: 'left', padding: '8px' }}>Contract ID</th>
                <th style={{ textAlign: 'left', padding: '8px' }}>Year</th>
                <th style={{ textAlign: 'left', padding: '8px' }}>Index Status</th>
                <th style={{ textAlign: 'left', padding: '8px' }}>Size</th>
                <th style={{ textAlign: 'left', padding: '8px' }}>Last Modified</th>
                <th style={{ textAlign: 'left', padding: '8px' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {indexes.map((index) => (
                <tr key={`${index.contractId}-${index.year}`} style={{ borderBottom: '1px solid #000' }}>
                  <td style={{ padding: '8px' }}>{index.contractId}</td>
                  <td style={{ padding: '8px' }}>{index.year}</td>
                  <td style={{ padding: '8px', color: index.indexAvailable ? 'green' : 'red' }}>
                    {index.indexAvailable ? 'Available' : 'Missing'}
                  </td>
                  <td style={{ padding: '8px' }}>{index.sizeMB ? `${index.sizeMB} MB` : '-'}</td>
                  <td style={{ padding: '8px' }}>{index.lastModified ? new Date(index.lastModified).toLocaleString() : '-'}</td>
                  <td style={{ padding: '8px' }}>
                    <a href={index.url} target="_blank" rel="noopener noreferrer" style={{ color: '#007acc' }}>View</a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <pre style={{ marginTop: '20px', background: '#f5f5f5', padding: '15px', borderRadius: '4px' }}>
No index files found. Index generation is managed by a separate Step Function.
          </pre>
        )}
      </div>
    </div>
  );
};

export default IndexDashboard;

